module.exports = __webpack_public_path__ + "static/img/domestic_sales.810e7a06.png";